import useTranslate from 'hooks/useTranslate';
import { Button, Image, Modal, Stack } from 'react-bootstrap';
import useCommonStore from 'store/common';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { isMobileOnly } from 'react-device-detect';
import './styles.scss';

const WaitingPage: React.FC<any> = () => {
	const { modalConfig = {} }: any = useCommonStore((state) => state);
	return (
		<Modal.Body>
			<Stack
				className={`gap-5 text-center ${isMobileOnly ? 'align-items-center justify-content-center h-100' : ''}`}
			>
				<div className="d-flex flex-column gap-2">
					{modalConfig?.data?.name && (
						<h2 className="fw-bold mb-0 title">{modalConfig.data.name}</h2>
					)}
					{modalConfig?.data?.message && (
						<span className="fw-bold mb-0 subtitle">{modalConfig.data.message}</span>
					)}
				</div>
				<Image
					src={modalConfig?.data?.profileImage || IMAGE_PATHS?.UserDefault}
					alt="profile-image"
					className="profile-img pulse"
					loading="lazy"
				/>
				<div className="edit-modal-actions d-flex gap-5  justify-content-center">
					{modalConfig?.data?.declineBtn && (
						<div className="d-flex flex-column gap-1 align-items-center">
							<Button
								className=" decline-btn rounded-pill border-0 p-0"
								onClick={() => modalConfig?.data?.onDeclineBtnClick()}
							>
								<i className="ri-phone-fill"></i>
							</Button>
							<span className="btn-text">{modalConfig?.data?.declineBtn}</span>
						</div>
					)}
					{modalConfig?.data?.acceptBtn && (
						<div className="d-flex flex-column gap-1 align-items-center">
							<Button
								className="accept-btn rounded-pill border-0 p-0"
								onClick={() => modalConfig?.data?.onAcceptBtnClick()}
							>
								<i className="ri-phone-fill"></i>
							</Button>
							<span className="btn-text">{modalConfig?.data?.acceptBtn}</span>
						</div>
					)}
					{modalConfig?.data?.cancelBtn && (
						<div className="d-flex flex-column gap-1 align-items-center">
							<Button
								className="transparent-btn cancel-btn rounded-pill border-0 p-0"
								onClick={() => modalConfig?.data?.onCancelBtnClick()}
							>
								<i className="ri-close-large-fill"></i>
							</Button>
							<span className="btn-text">{modalConfig?.data?.cancelBtn}</span>
						</div>
					)}
				</div>
			</Stack>
		</Modal.Body>
	);
};

export default WaitingPage;
